import * as ActionType from '../constants/ActionType'
import * as api from '../api/api';
import * as  documentStorageActions from './documentStorage';

function requestConfiguratorData() {
    return {
        type: ActionType.REQUEST_CONFIGURATOR_DATA
    };
}

function refreshConfiguratorData() {
    return {
        type: ActionType.REFRESH_CONFIGURATOR_DATA
    };
}

function receiveConfiguratorData(documentId, json) {
    var modifiedJson = json;
        modifiedJson.id = documentId; // TODO ... remove this on real API - calls
    return {
        type: ActionType.RECEIVE_CONFIGURATOR_DATA,
        json: modifiedJson,
        documentId: documentId
    };
}

export function getConfiguratorDataByDocument(documentId) {
    return (dispatch, getState) => {
        if ( isConfiguratorDataLoaded(getState(), documentId) ) {
            // Let the calling code know there's nothing to wait for.
            return Promise.resolve();
        } else {
            // Dispatch a thunk from thunk!

            return dispatch(fetchConfiguratorDataByDocument(documentId))
                .then(
                    () => dispatch(documentStorageActions.getDocumentStorages())
                );
        }
    };
}

export function refreshConfiguratorDataByDocument(documentId) {
    return function (dispatch, getState) {
        dispatch(refreshConfiguratorData());
        return dispatch(fetchConfiguratorDataByDocument(documentId))
            .then(
                () => dispatch(documentStorageActions.getDocumentStorages())
            );
    }
}

function isConfiguratorDataLoaded(globalState, documentId) {
    var loaded = false;
    var storedData = globalState.configurator.data;
    storedData.map(function (entry) {
       if (entry.id == documentId) {
           loaded = true;
       }
    });

    return loaded;
}

function fetchConfiguratorDataByDocument(documentId) {
    return function (dispatch) {
        dispatch(requestConfiguratorData());

        // Return a promise to wait for
        // (this is not required by thunk middleware, but it is convenient for us)
        // return fetch(`/api-mocks/configuratorData.json?documentID=` + documentId)
        //return fetch(`http://plsk.local.dw.lan/app_dev.php/api/document/` + documentId, {
        //    credentials: 'include' // @see ... https://www.npmjs.com/package/whatwg-fetch - sending cookies
        //})
        return api.getConfiguratorData(documentId)
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(json =>
                // We can dispatch many times!
                dispatch(receiveConfiguratorData(documentId, json))
            )
            //.catch(error => {
                // console.log(`Request failed: ${error}`);
            //})
            ;
    };
}


// WEBPACK FOOTER //
// ./src/js/actions/configurator.js